import { useNavigate } from "react-router-dom";
import { useNotificationCount } from "@/hooks/useNotificationCount";

export function NotificationBell() {
  const navigate = useNavigate();
  const { count, isLoading } = useNotificationCount();

  return (
    <button
      type="button"
      aria-label="Notifications"
      className="relative inline-flex items-center rounded-md p-2 text-gray-600 hover:bg-gray-100 hover:text-gray-900"
      onClick={() => navigate("/notifications")}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        className="h-6 w-6"
        aria-hidden="true"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0"
        />
      </svg>
      {!isLoading && count > 0 && (
        <span className="absolute -right-0.5 -top-0.5 flex h-5 w-5 items-center justify-center rounded-full bg-red-500 text-xs font-bold text-white">
          {count}
        </span>
      )}
    </button>
  );
}
